import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './pricingsection.css';
import { useNavigate } from 'react-router-dom';
import RegisterFlow from '../registerflow/registerflow';

const Pricing = ({ className, hideTopSections, showPrice, page, onToggleFeatureTable }) => {
  const navigate = useNavigate();
  const [isYearly, setIsYearly] = useState(true);
  // const [clickedStates, setClickedStates] = useState({
  //   card1: false,
  //   card2: false,
  //   card3: false,
  // });

  const handleToggle = () => {
    setIsYearly(!isYearly);
  };

  const handleButtonClick = () => {
    navigate('/demoform');
  };

  // const handleClick = (cardKey) => {
  //   setClickedStates(prevState => ({
  //     ...prevState,
  //     [cardKey]: !prevState[cardKey],
  //   }));
  //   handleViewComparisonClick();
  // };

  // const handleViewComparisonClick = () => {
  //   if (page === 'pricingprelogin') {
  //     onToggleFeatureTable();
  //   } else if (page === 'searchresults') {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //     navigate('/pricing-prelogin', {
  //       state: {
  //         showFeatureTable: false,
  //       }
  //     });
  //   } else {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //     navigate('/pricing-prelogin', { state: { showFeatureTable: false } });
  //   }
  // };

  // const handleKnowMoreClick = () => {
  //   if (!sessionStorage.getItem("initialScrollPosition")) {
  //     sessionStorage.setItem("initialScrollPosition", window.scrollY); 
  //   }
  //   sessionStorage.setItem("scrollPosition", window.scrollY);
  //   window.location.href = "/pricing-prelogin"; 
  // };
  // const handleKnowMoreClick = () => {
  //   if (!sessionStorage.getItem("initialScrollPosition")) {
  //     sessionStorage.setItem("initialScrollPosition", window.scrollY);
  //   }
  //   sessionStorage.setItem("scrollPosition", window.scrollY);
  //   window.location.href = "/login";
  // };

  const [registerPopupVisible, setRegisterPopupVisible] = useState(false);

  const openRegisterPopup = () => {
    setRegisterPopupVisible(true);
  };

  const closeRegisterPopup = () => {
    setRegisterPopupVisible(false);
  };

  const getButtonText = () => {
    return page === 'searchresults' || page === 'homepage' ? 'Contact Us' : 'Contact Us';
  };

  // const handleContactSalesClick = () => {
  //   sessionStorage.setItem("scrollPosition", window.scrollY); // Store scroll position
  //   window.location.href = "/contact-sales";
  // };
  const handleContactSalesClick = () => {
    if (!sessionStorage.getItem("initialScrollPosition")) {
      sessionStorage.setItem("initialScrollPosition", window.scrollY);
    }
    sessionStorage.setItem("scrollPosition", window.scrollY);
    window.location.href = "/contact-sales";
  };


  const pricingData = {
    card1: { yearly: 15000, monthly: 20000 },
    card2: { yearly: 25000, monthly: 30000 },
    card3: { yearly: 37500, monthly: 45000 },
  }
  const renderTopContent = () => {
    if (page === 'homepage') {
      return (
        <>
          <div className="top-section">Clear. Transparent. Competitive.</div>
          <div className="middle-section">Simple and honest plans that grow with your business</div>
          <div className="membership-options">
            {/* <div className="toggle-container">
              <span className={`toggle-label-month-home ${!isYearly ? 'active' : ''}`}>Monthly</span>
              <label className="switch">
                <input type="checkbox" onChange={handleToggle} checked={isYearly} />
                <span className="slider round"></span>
              </label>
              <span className={`toggle-label-year-home ${isYearly ? 'active' : ''}`}>Yearly</span>
            </div> */}
          </div>
        </>
      );
    } else if (page === 'searchresults') {
      return (
        <>
          <div className="top-heading">Getting started is easy.</div>
          <div className="top-button">
            <button className="top-card-button" onClick={handleButtonClick}>
              Book a Demo
            </button>
          </div>
          <div className="top-line">Subscribe Now</div>
          <div className="middle-line">to see the full search results.</div>
          <div className="membership-options">
            {/* <div className="toggle-container">
              <span className={`toggle-label-month ${!isYearly ? 'active' : ''}`}>Monthly</span>
              <label className="switch">
                <input type="checkbox" onChange={handleToggle} checked={isYearly} />
                <span className="slider round"></span>
              </label>
              <span className={`toggle-label-year ${isYearly ? 'active' : ''}`}>Yearly</span>
            </div> */}
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="top-line">Choose the Best Plan for you</div>
          <div className="membership-options">
            {/* <div className="toggle-container">
              <span className={`toggle-label-month ${!isYearly ? 'active' : ''}`}>Monthly</span>
              <label className="switch">
                <input type="checkbox" onChange={handleToggle} checked={isYearly} />
                <span className="slider round"></span>
              </label>
              <span className={`toggle-label-year ${isYearly ? 'active' : ''}`}>Yearly</span>
            </div> */}
          </div>
        </>
      );
    }
  };

  return (
    <div className={`pricing-section ${className}`}>

      {renderTopContent()}
      <div className="black-background">
        <Container>
          <Row>
            <Col>
              <Card className="pricing-card-1" style={{ borderRadius: '24px' }}>
                <Card.Body className='pricing-card-content-1'>
                  <h4 className="platinum-1">
                    Essential
                  </h4>
                  {/* <Card.Text className="amount">
                    <span style={{fontSize: '20px'}}>{'\u20B9'}</span> {isYearly ? pricingData.card1.yearly : pricingData.card1.monthly}
                    <span>{' '}/{' '}{isYearly ? 'month billed annually' : 'month billed monthly'}</span>
                  </Card.Text> */}
                  <Card.Text className="description">The perfect starter plan for your primary hiring needs</Card.Text>
                  <div className="card-button">
                    <button className="contact-button" onClick={handleContactSalesClick}>
                      {getButtonText()}
                    </button>
                  </div>
                  <div className='elite-horizontal-ruler'></div>
                  <br />
                  <div className="includes-heading">Get 150 pre-assessed profiles</div>
                  <br />
                  <div className="includes-heading">Includes :</div>
                  <ul className="includes-list-2">
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Data Privacy
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Data Encryption
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Activity Log
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Sub Users
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Advanced Search Results
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Download Profiles                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Customer Support
                    </li>
                  </ul>
                  {/* <div className="detailed-comparison-link" onClick={() => handleClick('card1')}>
                    View Detailed Comparison
                    <span className={`arrow-icon ${clickedStates.card1 ? 'rotate' : ''}`}> &gt; </span>
                  </div> */}
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card
                className="pricing-card-2"
                style={{
                  borderRadius: '24px',
                  border: '4px solid',
                }}
              >
                <Card.Body className='pricing-card-content-2'>
                  <h4 className="platinum-1">Essential +</h4>
                  {/* <Card.Text className="amount-1">
                    <span style={{fontSize: '20px'}}>{'\u20B9'}</span> {isYearly ? pricingData.card2.yearly : pricingData.card2.monthly}
                    <span>{' '}/{' '}{isYearly ? 'month billed annually' : 'month billed monthly'}</span>
                  </Card.Text> */}
                  <Card.Text className="description-1">
                    Level up your hiring with our growth plan tailored to your needs
                  </Card.Text>
                  <div className="card-button-1">
                    <button className="contact-button-1" onClick={handleContactSalesClick}>
                      {getButtonText()}
                    </button>
                  </div>
                  <div className='essential-horizontal-ruler'></div><br />
                  <div className="includes-heading-1">Get 250 pre-assessed profiles</div>
                  <br />
                  <div className="includes-heading-1">Includes :</div>
                  <ul className="includes-list-2">
                    <li>
                      <span className="tickmark-1">
                        <i className="fas fa-check"></i>
                      </span>
                      Data Privacy
                    </li>
                    <li>
                      <span className="tickmark-1">
                        <i className="fas fa-check"></i>
                      </span>
                      Data Encryption
                    </li>
                    <li>
                      <span className="tickmark-1">
                        <i className="fas fa-check"></i>
                      </span>
                      Activity Log
                    </li>
                    <li>
                      <span className="tickmark-1">
                        <i className="fas fa-check"></i>
                      </span>
                      Sub Users
                    </li>
                    <li>
                      <span className="tickmark-1">
                        <i className="fas fa-check"></i>
                      </span>
                      Advanced Search Filters
                    </li>
                    <li>
                      <span className="tickmark-1">
                        <i className="fas fa-check"></i>
                      </span>
                      Download Profiles
                    </li>
                    <li>
                      <span className="tickmark-1">
                        <i className="fas fa-check"></i>
                      </span>
                      Customer Support
                    </li>
                  </ul>

                  {/* <div className="detailed-comparison-link" onClick={() => handleClick('card2')}>
                    View Detailed Comparison
                    <span className={`arrow-icon ${clickedStates.card2 ? 'rotate' : ''}`}> &gt; </span>
                  </div> */}
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="pricing-card-3" style={{ borderRadius: '24px' }}>
                <Card.Body className='pricing-card-content-3'>
                  <h4 className="platinum-1">Elite</h4>
                  {/* <Card.Text className="amount">
                    <span style={{fontSize: '20px'}}>{'\u20B9'}</span> {isYearly ? pricingData.card3.yearly : pricingData.card3.monthly}
                    <span>{' '}/{' '}{isYearly ? 'month billed annually' : 'month billed monthly'}</span>
                  </Card.Text> */}
                  <Card.Text className="description">Your ultimate, all-in-one hiring solution</Card.Text>
                  <div className="card-button-elite">
                    <button className="contact-button-elite" onClick={handleContactSalesClick}>
                      {getButtonText()}
                    </button>
                  </div>
                  <div className='elite-horizontal-ruler'></div><br />
                  <div className="includes-heading">Get 500 pre-assessed profiles</div>
                  <br />
                  <div className="includes-heading">Includes :</div>
                  <ul className="includes-list-2">
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Data Privacy
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Data Encryption
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Activity Log
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Sub Users
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Advanced Search Filters
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Download Profiles
                    </li>
                    <li style={{ color: '#2D3E50' }}>
                      <span className="tickmark-1">
                        <i className="fas fa-check" style={{ color: '#FFFFFF' }}></i>
                      </span>
                      Customer Support
                    </li>
                  </ul>
                  {/* <div className="detailed-comparison-link" onClick={() => handleClick('card3')}>
                    View Detailed Comparison
                    <span className={`arrow-icon ${clickedStates.card3 ? 'rotate' : ''}`}> &gt; </span>
                  </div> */}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {!hideTopSections && (
        <div className="bottom-button">
          <button className="button" onClick={openRegisterPopup}>
            Start Free Trial
          </button>

        </div>
      )}
      <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />

    </div>
  );
};

export default Pricing;